import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "mcp-carousel-card__head" }
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "mcp-carousel-card__chips" }
const _hoisted_6 = { class: "mcp-carousel-card__body" }
const _hoisted_7 = { class: "text-h6 mcp-carousel-card__title" }
const _hoisted_8 = { class: "text-body-2 text-medium-emphasis mcp-carousel-card__description" }
const _hoisted_9 = {
  key: 0,
  class: "mcp-carousel-card__meta"
}
const _hoisted_10 = {
  key: 0,
  class: "mcp-carousel-card__meta-row"
}
const _hoisted_11 = {
  key: 1,
  class: "mcp-carousel-card__meta-row"
}
const _hoisted_12 = {
  key: 2,
  class: "mcp-carousel-card__meta-row"
}
const _hoisted_13 = { class: "mcp-carousel-card__foot" }
const _hoisted_14 = { class: "mcp-carousel-card__tools" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "mcp-carousel-card h-100",
    variant: "outlined"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass([
          'mcp-carousel-card__tile',
          { 'mcp-carousel-card__tile--fallback': !_ctx.showStandaloneIcon }
        ]),
          "aria-label": `${_ctx.item.title} server tile`
        }, [
          (_ctx.showStandaloneIcon)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _ctx.iconSrc,
                alt: `${_ctx.item.title} icon`,
                class: "mcp-carousel-card__tile-image",
                onError: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onIconError && _ctx.onIconError(...args)))
              }, null, 40, _hoisted_3))
            : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.tileLabel), 1))
        ], 10, _hoisted_2),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stateChips, (chip) => {
            return (_openBlock(), _createBlock(_component_v_chip, {
              key: chip.key,
              color: chip.color,
              size: "x-small",
              variant: "tonal"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(chip.label), 1)
              ]),
              _: 2
            }, 1032, ["color"]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.item.title), 1),
        _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.item.description), 1),
        (_ctx.hostnameLabel || _ctx.repositoryHostLabel || _ctx.item.licenseName)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              (_ctx.hostnameLabel)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createVNode(_component_v_icon, { size: "x-small" }, {
                      default: _withCtx(() => _cache[1] || (_cache[1] = [
                        _createTextVNode("mdi-link-variant")
                      ])),
                      _: 1,
                      __: [1]
                    }),
                    _createElementVNode("span", null, _toDisplayString(_ctx.hostnameLabel), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.repositoryHostLabel)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createVNode(_component_v_icon, { size: "x-small" }, {
                      default: _withCtx(() => _cache[2] || (_cache[2] = [
                        _createTextVNode("mdi-source-repository")
                      ])),
                      _: 1,
                      __: [2]
                    }),
                    _createElementVNode("span", null, _toDisplayString(_ctx.repositoryHostLabel), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.item.licenseName)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createVNode(_component_v_icon, { size: "x-small" }, {
                      default: _withCtx(() => _cache[3] || (_cache[3] = [
                        _createTextVNode("mdi-scale-balance")
                      ])),
                      _: 1,
                      __: [3]
                    }),
                    _createElementVNode("span", null, _toDisplayString(_ctx.item.licenseName), 1)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_v_icon, {
            size: "small",
            color: "primary"
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createTextVNode("mdi-tools")
            ])),
            _: 1,
            __: [4]
          }),
          _createElementVNode("span", null, _toDisplayString(_ctx.toolCountLabel), 1)
        ]),
        _createVNode(_component_v_btn, {
          color: "primary",
          onClick: _ctx.emitPrimaryAction
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.item.primaryActionLabel), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _: 1
  }))
}